import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'With Hermo, I instantly spot the founder emails that fit my criteria - which means I respond quickly and never miss a great team.',
    author: 'Sarah Johnson',
    role: 'Super Angel',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }, {
    quote: 'I no longer have to deal with the admin of adding school events to the family calendar - or even worse the chaos when we miss one!',
    author: 'Michael Chen',
    role: 'Product Manager & Parent',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }, {
    quote: 'Herno takes my invoices, receipts, and expenses and automatically updates the P&L for each of my properties. Goodbye tax admin!',
    author: 'Emma Rodriguez',
    role: 'Private Landlord',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }];
  return <section id="testimonials" className="py-32 px-6 md:px-12 lg:px-24 bg-[#fffefc]" data-id="element-168">
      <div className="max-w-7xl mx-auto" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-[#2D1810] mb-4" data-id="element-171">
            What Our Users Say
          </h2>
          <p className="text-xl text-[#6B5244] max-w-2xl mx-auto" data-id="element-172">
            Hermo is helping professionals and busy parents take control of
            their inbox
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-173">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#fffefc] rounded-xl p-8 shadow-lg border border-[#E8DFD8] flex flex-col" data-id="element-174">
              <div className="flex mb-4" data-id="element-175">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-[#D4A574] fill-[#D4A574]" data-id="element-176" />)}
              </div>
              <p className="text-[#6B5244] italic mb-6 flex-grow" data-id="element-177">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-178">
                <img src={testimonial.avatar} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-179" />
                <div data-id="element-180">
                  <h4 className="font-semibold text-[#2D1810]" data-id="element-181">
                    {testimonial.author}
                  </h4>
                  <p className="text-[#6B5244] text-sm" data-id="element-182">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}